import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaRichText } from "../../../../modules/content/components/WohaRichText/WohaRichText";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";
export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <WohaRichText
          className="text-lg leading-8 text-graphite [&_h2]:mt-12 [&_h2]:font-satoshi [&_h2]:text-3xl [&_h2]:font-medium [&_h2]:leading-tight [&_h2]:text-charcoal [&_h2:first-child]:mt-0"
          content={content}
        />
      </div>
    </WohaSection>
  );
};
WysiwygBlock.displayName = "Block::WysiwygBlock";
